(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eigen-ontwerp-routes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function prepareChoices() {
      document.querySelectorAll('[data-eo-order]').forEach(link => {
        const panel = document.getElementById('eo-order-' + link.dataset.eoOrder);
        if (!panel) return;
        link.setAttribute('role', 'button');
        link.setAttribute('aria-controls', panel.id);
        link.setAttribute('aria-expanded', String(panel.closest('.shopify-section').classList.contains('eo-inline-open')));
      });
    }
    function closePanels() {
      document.querySelectorAll('[data-eo-inline]').forEach(panel => panel.closest('.shopify-section').classList.remove('eo-inline-open'));
      document.querySelectorAll('[data-eo-order]').forEach(link => {
        link.setAttribute('aria-expanded', 'false');
        link.closest('.eo-route-card')?.classList.remove('eo-route-selected');
      });
    }
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-eo-order]');
      if (link) {
        const panel = document.getElementById('eo-order-' + link.dataset.eoOrder);
        if (!panel) return;
        event.preventDefault();
        const wasOpen = link.getAttribute('aria-expanded') === 'true';
        closePanels();
        if (wasOpen) return;
        panel.closest('.shopify-section').classList.add('eo-inline-open');
        link.setAttribute('aria-expanded', 'true');
        link.closest('.eo-route-card')?.classList.add('eo-route-selected');
        requestAnimationFrame(() => {
          panel.querySelector('h2')?.focus({preventScroll: true});
          panel.scrollIntoView({block:'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
      }
      const close = event.target.closest('[data-eo-close]');
      if (close) {
        const key = close.closest('[data-eo-inline]').dataset.eoInline;
        closePanels();
        document.querySelectorAll('[data-eo-order]').forEach(link => {
          if (link.dataset.eoOrder === key) link.focus();
        });
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === ' ' && event.target.matches('[data-eo-order][role="button"]')) {
        event.preventDefault();
        event.target.click();
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareChoices);
    else prepareChoices();
    document.addEventListener('shopify:section:load', prepareChoices);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eigen-ontwerp-slider"] && !Shopify.designMode) return;
  try {
    
  const initializeEigenDesignSliders = (scope = document) => {
    scope.querySelectorAll('[data-eigen-slider]').forEach((slider) => {
      if (slider.dataset.sliderReady === 'true') return;

      const track = slider.querySelector('[data-slider-track]');
      const viewport = slider.querySelector('[data-slider-viewport]');
      const slides = Array.from(slider.querySelectorAll('[data-slider-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
      const previous = slider.querySelector('[data-slider-previous]');
      const next = slider.querySelector('[data-slider-next]');
      let activeIndex = 0;
      let timer;

      if (!track || slides.length < 2) return;

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;

        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === activeIndex);
        });
      };

      const stopAutoplay = () => window.clearInterval(timer);
      const startAutoplay = () => {
        stopAutoplay();
        if (slider.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), Number(slider.dataset.cycleSpeed));
      };

      previous?.addEventListener('click', () => {
        showSlide(activeIndex - 1);
        startAutoplay();
      });

      next?.addEventListener('click', () => {
        showSlide(activeIndex + 1);
        startAutoplay();
      });

      viewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
        if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
      });

      slider.addEventListener('pointerenter', stopAutoplay);
      slider.addEventListener('pointerleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', startAutoplay);
      slider.dataset.sliderReady = 'true';
      startAutoplay();
    });
  };

  initializeEigenDesignSliders();
  document.addEventListener('shopify:section:load', (event) => initializeEigenDesignSliders(event.target));

  } catch(e) { console.error(e); }
})();
})();
